import React from "react";
import { FormControl, Input, Textarea, Button, Flex, Container } from "@airbus/components-react";
import { ContactController} from "../controller/ContactController";
import eventBus from "../eventBus/EventBus";

import '../css/Forms.css';

class ContactEditForm extends React.Component {

    constructor(props){
        super(props);

        //states
        this.state={
            form:{
                id: props.id,
                name: props.name,                   //Form handler
                firstname: props.firstname,
                mail: props.mail,
                phone: props.phone,
                adresse1: props.adresse1,
                adresse2: props.adresse2,
                postcode: props.postcode,
                city: props.city,
                comment: props.comment,
            },
            windowWidth: window.innerWidth,     //screen width 
            windowHeight: window.innerHeight,   //screen height
        }

         //Notification params
         this.setNotification=this.props.notificationHandler;  //call parent notification handler

    }


    componentDidUpdate = () => {
      
        window.addEventListener("resize", this.handleResize);
    }

    /*Handle screen size*/
    handleResize = (e) => {
      
        //debugger;
        this.setState({ 
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight
        });
    
    };

    /**
     * RENDERING
     * @returns dom
     */
     render() {

        return(
            <div>

                {/*NAME*/}
                <Flex wrap={true} direction="row" >
                <FormControl
                    className="controlForm"
                    error={!this.nameValid()}
                    errorText="Obligatoire"
                    label="Nom"
                    placeholder="Nom"
                    required
                    style={{height:100}}
                >
                    <Input value={this.state.form.name} onChange={this.onChangeName} />
                </FormControl>

                {/*FIRST NAME*/}
                <FormControl
                    className="controlForm"
                    error={!this.firstnameValid()}
                    errorText="Obligatoire"
                    label="Prénom"
                    placeholder="Prénom"
                    required
                    style={{height:100}}
                >
                    <Input value={this.state.form.firstname} onChange={this.onChangeFirstname} />
                </FormControl>

                {/*MAIL*/}
                <FormControl
                    className="controlForm"
                    label="Mail"
                    placeholder="Mail"
                    style={{height:100}}
                >
                    <Input value={this.state.form.mail} onChange={this.onChangeMail} />
                </FormControl>

                {/*PHONE*/}
                <FormControl
                    className="controlForm"
                    label="Téléphone"
                    placeholder="Téléphone"
                    style={{height:100}}
                >
                    <Input value={this.state.form.phone} onChange={this.onChangePhone} />
                </FormControl>
                </Flex>

                {/*ADRESSE*/}
                <Container until="md" className="container-left" style={{paddingLeft:"0px"}}>
                    <Flex justify="start" wrap={true} direction="row" >
                    <FormControl
                        className="FullWidthcontrolForm"
                        label="Adresse"
                        placeholder="Adresse 1"
                        //style={{width:772}}
                    >
                        <Input value={this.state.form.adresse1} onChange={this.onChangeAdresse1} />
                    </FormControl>
                    </Flex>
                </Container>

                <Container until="md" className="container-left" style={{paddingLeft:"0px", paddingTop:"10px"}}>
                <Flex wrap={true} direction="row" >
                    <FormControl
                        className="FullWidthcontrolForm"
                        placeholder="Adresse 2"
                        //style={{width:772}}
                    >
                        <Input value={this.state.form.adresse2} onChange={this.onChangeAdresse2} />
                    </FormControl>
                </Flex>
                </Container>

                {/*Code Postal*/}
                <Flex wrap={true} direction="row" >
                <FormControl
                    className="controlForm"
                    label="Code postal"
                    placeholder="Code Postal"
                    style={{height:100, paddingTop:20}}
                >
                    <Input value={this.state.form.postcode} onChange={this.onChangePostCode} />
                </FormControl>

                {/*City*/}
                <FormControl
                    className="controlForm"
                    label="Ville"
                    placeholder="Ville"
                    style={{height:100, paddingTop:20}}
                >
                    <Input value={this.state.form.city} onChange={this.onChangeCity} />
                </FormControl>

                </Flex>

                {/*Commentaires*/}
                <Container until="md" className="container-left" style={{paddingLeft:"0px"}}>
                <Flex wrap={true} direction="row" >
                <FormControl
                    className="FullWidthcontrolForm"
                    label="Commentaires"
                    placeholder="Commentaires"
                    style={{paddingTop:20}}
                >
                    <Textarea value={this.state.form.comment} onChange={this.onChangeComment} />
                </FormControl>
                </Flex>
                </Container>

                {/*SUBMIT*/}
                <Flex wrap={true} direction="row" >
                    <FormControl className="button-controlForm">       
                        <Button variant="primary" 
                                        onClick = {this.onEditContactSubmit}
                                        disabled = {!this.nameValid() 
                                            || !this.firstnameValid()
                                            }
                                        style={{
                                            width: "100%"
                                            }}>
                                        MODIFIER CONTACT
                        </Button>
                    </FormControl>
                </Flex>


            </div>


        )}
    

    /**
     * EVENTS
     */
    
    //Vérification Name
    nameValid = () => {
        return this.state.form.name !== undefined && this.state.form.name.length > 0;
    };


    //NAME Input Change handler
    onChangeName = (event) => {
         
        let formData = this.state.form;
        formData.name = event.target.value;
        
        this.setState({form:formData});
         
    }

    //Vérification Name
    firstnameValid = () => {
        return this.state.form.firstname !== undefined && this.state.form.firstname.length > 0;
    };


    //FIRSTNAME Input Change handler
    onChangeFirstname = (event) => {
         
        let formData = this.state.form;
        formData.firstname = event.target.value;
        
        this.setState({form:formData});
         
    }

    //MAIL Input Change handler
    onChangeMail = (event) => {
         
        let formData = this.state.form;
        formData.mail = event.target.value;
        
        this.setState({form:formData});
         
    }

    //PHONE Input Change handler
    onChangePhone = (event) => {
         
        let formData = this.state.form;
        formData.phone = event.target.value;
        
        this.setState({form:formData});
         
    }

    //Adresse1 Input Change handler
    onChangeAdresse1 = (event) => {
         
        let formData = this.state.form;
        formData.adresse1 = event.target.value;
        
        this.setState({form:formData});
         
    }

    //Adresse2 Input Change handler
    onChangeAdresse2 = (event) => {
         
        let formData = this.state.form;
        formData.adresse2 = event.target.value;
        
        this.setState({form:formData});
         
    }

    //PostCode Input Change handler
    onChangePostCode = (event) => {
         
        let formData = this.state.form;
        formData.postcode = event.target.value;
        
        this.setState({form:formData});
         
    }

    //City Input Change handler
    onChangeCity = (event) => {
         
        let formData = this.state.form;
        formData.city = event.target.value;
        
        this.setState({form:formData});
         
    }

    //Comment Input Change handler
    onChangeComment = (event) => {
         
        let formData = this.state.form;
        formData.comment = event.target.value;
        
        this.setState({form:formData});
         
    }

    //Submit Contact creation
    onEditContactSubmit = async (event) =>  {

        let formData = this.state.form;
        
        let response = await new ContactController().updateContact( formData.id,
                                                                    formData.name,
                                                                    formData.firstname,
                                                                    formData.mail,
                                                                    formData.phone,
                                                                    formData.adresse1,
                                                                    formData.adresse2,
                                                                    formData.postcode,
                                                                    formData.city,
                                                                    formData.comment
                                                                    );
        
        if(response === undefined){
            //erreur API call
            this.setNotification(true,{
                notifVariant: "error",
                notifMessage:"API erreur: le contact n'a pas pu être modifé",
                notifDescription:null
              });
   
        }
        else if (response.response === "200"){           
            //Go back to list view
            //Export to event Bus for main component state refresh
            eventBus.dispatch("contactlistview", { contactlistview: true });
            
        }
        else{
            
            //API return <> 200
            this.setNotification(true,{
                notifVariant: "error",
                notifMessage:"Erreur lors de la modification du contact",
                notifDescription: response.response+": "+response.responseDescription
              });

        }
        
    }

    
}

export default ContactEditForm;